import ModalEditTable from '../CRUDUtils/ModalEditTable';
import { Link } from 'react-router-dom';
import { dateSorter } from '../../utils';
import { isBeforeToday } from '../../utils';
import { useIsSuperAdmin, useMobileStore } from '../../store';
import React, { useState, useEffect } from 'react';
import { Modal, Select, Space, Input } from 'antd';
import './Projects.scss';

export default function ProjectsPage() {
  const [searchInput, setSearchInput] = useState('')
  const isSuperAdmin = useIsSuperAdmin();
  const isMobile = useMobileStore((state) => state.isMobile);
  const { Search } = Input;
  
  const columns = [
    {
      title: 'Name',
      dataIndex: 'project_name',
      key: 'project_name',
      sorter: { compare: (a, b) => a.project_name.localeCompare(b.project_name), multiple: 4 }
    },
    {
      title: 'Customer',
      dataIndex: ['customer', 'name'],
      key: 'customer_name',

      sorter: { compare: (a, b) => a.customer.name.localeCompare(b.customer.name), multiple: 3 }
    },
    {
      title: 'Start Date',
      dataIndex: 'unix_start_date',
      key: 'unix_start_date',
      render: (value) => {
        const date = new Date(value);
        // If it's invalid or equals -1 timestamp, show blank
        if (isNaN(date.getTime()) || date.getTime() === -1000) return '';
        return date.toLocaleString(); // or format however you prefer
      },
      sorter: { compare: dateSorter('unix_start_date'), multiple: 2 }, defaultSortOrder: 'ascend'
    },
    {
      title: 'End Date',
      dataIndex: 'unix_end_date',
      key: 'unix_end_date',
      render: (value) => {
        const date = new Date(value);
        // If it's invalid or equals -1 timestamp, show blank
        if (isNaN(date.getTime()) || date.getTime() === -1000) return '';
        return date.toLocaleString(); // or format however you prefer
      },
      sorter: { compare: dateSorter('unix_end_date'), multiple: 1 }, defaultSortOrder: 'descend'
    },
  ];

  const formFields = [
    {
      name: 'project_id',
      label: 'Project ID',
      type: 'textarea',
      placeholder: 'Project ID',
      disabled: true,
    },
    {
      name: 'project_name',
      label: 'Project Code',
      type: 'textarea',
      placeholder: 'Project Code',
      rules: [{ required: true, message: 'Must Enter a Location Name!' }]
    },
    {
      name: 'customer_id',
      label: 'Customer',
      type: 'select',
      optionsEndpoint: '/read/customers',
      optionsLabel: ['name'], // Multiple fields!
      labelSeparator: ' - ',  // Optional, defaults to ' - '
      optionsValue: 'customer_id',
      searchable: true,
      rules: [{ required: true }],
    },
    {
      name: 'unix_start_date',
      label: 'Start Date',
      type: 'date',  // This makes it a date picker
      placeholder: 'Select start date',
      rules: [{ required: true, message: 'Must Select a Start Date!' }]
    },
    {
      name: 'unix_end_date',
      label: 'End Date',
      type: 'date',  // This makes it a date picker
      placeholder: 'Select end date',
      //rules: [{ required: true, message: 'Must Select an End Date!' }]
    },
  ];

  return (
    <div className='container-wrapper'>

      <div>
        <h2>Project Names</h2>
      </div>
      <div className={`project-filter-wrapper ${isSuperAdmin ? 'admin-margin' : ''}`}>
        <div className="project-filter-controls">
          {(<label className="project-filter-label">Filter by:</label>)}
          {React.createElement(isMobile ? React.Fragment : Space.Compact, {},
            (
              <Search
                placeholder="Project Name..."
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
              />
            )
          )}
        </div>
      </div>

      <ModalEditTable
        createEndpoint="create/projects"
        readEndpoint="read/projects"
        editEndpoint="update/projects"
        deleteEndpoint="delete/projects"
        columns={columns}
        formFields={formFields}
        searchQuery="project_name"
        searchInput={searchInput}
        rowClassName={(record) => {
          if (isBeforeToday(record.unix_end_date)) {
            return 'row-red';
          }
          return '';
        }}
      />
    </div>
  );
}